import React from "react";

const SKELETON_COLS = ["6%", "22%", "18%", "14%", "12%"];

const thStyle = {
  background: "linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%)",
  color: "#555",
  fontWeight: 600,
  fontSize: "12px",
  letterSpacing: "0.5px",
  padding: "10px 14px",
  borderBottom: "2px solid #e0e0e0",
  whiteSpace: "nowrap",
};

const TableSkeleton = () => (
  <div>
    <style>{`@keyframes shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }`}</style>
    <div style={{ overflowX: "auto" }}>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={thStyle}>-</th>
            <th style={thStyle}> -</th>
            <th style={thStyle}> -</th>
            <th style={thStyle}> -</th>
            <th style={{ ...thStyle, textAlign: "center" }}> -</th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: 5 }).map((_, rowIdx) => (
            <tr key={rowIdx}>
              {SKELETON_COLS.map((w, colIdx) => (
                <td
                  key={colIdx}
                  style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}
                >
                  <div
                    style={{
                      height: "14px",
                      width: w,
                      minWidth: "40px",
                      borderRadius: "6px",
                      background:
                        "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                      backgroundSize: "200% 100%",
                      animation: "shimmer 1.4s infinite",
                    }}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default TableSkeleton;
